angular.module('app')

	.controller('AboutController', ['$scope', '$timeout', function AboutController ($scope, $timeout)
	{
		var about = this;
		var aboutPage = document.getElementById('about_page');
	}]);
